// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jBmY","newExpiryDate":"styles_newExpiryDate__1gklf","footer":"styles_footer__3hjV3"};